import { Component, OnInit } from "@angular/core"
import { AuthService } from "src/app/services/auth.service"
import { Validators } from "@angular/forms"
import { FormBuilder } from "@angular/forms"
import { BaseService } from "../../../services/base.service"
import { Observable } from "rxjs"
import { map, startWith } from "rxjs/operators"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-signup-main",
	templateUrl: "./signup-main.component.html"
})
export class SignupMainComponent implements OnInit {
	public assets_version = environment.ASSETS_VERSION
	waitLogin = false
	usersGroupList: any
	filteredOptions: Observable<any>
	userTypeOptions = [
		{ value: 0, label: "Prospect" },
		{ value: 1, label: "Pre-sales" },
		{ value: 2, label: "Sales" }
	]
	private account_id: any

	constructor(
		private authService: AuthService,
		private fb: FormBuilder,
		private baseService: BaseService
	) {}

	public signUpForm = this.fb.group({
		name: ["", Validators.required],
		surname: ["", Validators.required],
		email: ["", [Validators.required, Validators.email]],
		company: ["", Validators.required],
		country: ["", Validators.required],
		type: ["", Validators.required]
	})

	ngOnInit() {
		this.getUsersGroups()
	}

	private getUsersGroups() {
		this.usersGroupList = []
		this.baseService.getUserGroups().subscribe(res => {
			if (res.length) {
				for (const obj of res) {
					this.usersGroupList.push(obj)
				}
				this.filteredOptions = this.signUpForm.controls["company"].valueChanges.pipe(
					startWith(""),
					map(value => this._filter(value))
				)
			}
		})
	}

	private _filter(value: string): string[] {
		const filterValue = value.toLowerCase()
		return this.usersGroupList.filter(option => option.Name.toLowerCase().includes(filterValue))
	}

	selectCompany(company) {
		if (company.Id) {
			this.account_id = company.Id
		} else {
			this.account_id = this.usersGroupList.filter(e => e.Name.includes(company.option.value))[0].Id
		}
	}

	get disabled() {
		if (this.signUpForm && this.signUpForm.valid) {
			return false
		} else {
			return true
		}
	}

	onSubmit() {
		if (this.disabled) {
			return
		}
		this.waitLogin = true
		const req = {
			user: {
				email: this.signUpForm.value.email,
				name: this.signUpForm.value.name,
				surname: this.signUpForm.value.surname,
				company: this.signUpForm.value.company,
				country: this.signUpForm.value.country,
				userType: this.signUpForm.value.type,
				account_id: this.account_id
			}
		}
		this.authService.signUp(req).subscribe(
			res => {
				this.signUpForm.patchValue({
					name: "",
					surname: "",
					email: "",
					company: "",
					country: "",
					type: "",
					account_id: ""
				})
				this.signUpForm.markAsUntouched()
				this.waitLogin = false
				this.authService.showSuccess(res.message)
			},
			err => {
				this.authService.showError(err)
				this.waitLogin = false
			}
		)
	}
}
